// extracted by mini-css-extract-plugin
export var cancelButton = "_nk-5";
export var content = "_nk-3";
export var createButton = "_nk-6";
export var drawerContainer = "_nk-0";
export var footer = "_nk-2";
export var header = "_nk-1";
export var orderFormColumn = "_nk-4";